/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2026-09-28 11:52:09
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-09-28 15:18:05
 */
/*
 * @Description: 大屏登录 token 管理
 */
const TOKEN_KEY = 'dashboardToken'

const listeners = []

export const getDashboardToken = () => localStorage.getItem(TOKEN_KEY) || ''

export const setDashboardToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const clearDashboardToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

// 注册 token 失效回调，返回解绑函数
export const onTokenInvalid = fn => {
  listeners.push(fn)
  return () => {
    const index = listeners.indexOf(fn)
    if (index > -1) listeners.splice(index, 1)
  }
}

export const emitTokenInvalid = () => {
  listeners.forEach(fn => fn())
}

// 登录校验入口（由 App 挂载登录弹窗后注册）
let loginEnsureFn = null
export const registerLoginEnsure = fn => {
  loginEnsureFn = fn
}
// 确保大屏登录有效（无 token/token 失效时弹登录，登录成功后继续），返回 Promise<boolean>
export const ensureDashboardLogin = () => (loginEnsureFn ? loginEnsureFn() : Promise.resolve(false))
